/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import React from 'react'

import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined'
import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined'
import { Paper, Stack } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'

export interface DialogTitleProps {
  id: string
  children?: React.ReactNode
  onNext: () => void
  onPrevious: () => void
}

const BootstrapDialogTitle = (props: DialogTitleProps) => {
  const { children, onNext, onPrevious, ...other } = props

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      <Stack
        direction="row"
        spacing={1}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
        }}
      >
        <IconButton aria-label="next task" disabled={!onNext} onClick={onNext}>
          <ArrowUpwardOutlinedIcon />
        </IconButton>
        <IconButton
          aria-label="previous task"
          disabled={!onPrevious}
          onClick={onPrevious}
        >
          <ArrowDownwardOutlinedIcon />
        </IconButton>
      </Stack>
    </DialogTitle>
  )
}

export interface QuickSolutionDialogProps {
  open: boolean
  selectedValue: string
  onClose: (value: string) => void
}

function QuickSolutionDialog(props: QuickSolutionDialogProps) {
  const { onClose, selectedValue, open } = props

  const handleClose = () => {
    onClose(selectedValue)
  }

  //  const handleListItemClick = (value: string) => {
  //    onClose(value)
  //  }

  return (
    <Dialog maxWidth="md" open={open} onClose={handleClose}>
      <BootstrapDialogTitle
        id="action-resolver-title"
        onNext={() => alert('To next')}
        onPrevious={() => alert('To previous')}
      >
        Согласуйте акт
      </BootstrapDialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'grey.100',
            p: 3,
            borderRadius: 1,
          }}
        >
          <Paper
            elevation={2}
            sx={{
              borderRadius: 1,
              width: 300,
              height: 450,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            Тут акт
          </Paper>
          <Paper
            elevation={2}
            sx={{
              ml: 2,
              width: 300,
              height: 450,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            Тут приложения
          </Paper>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button color="rejected" variant="contained" onClick={handleClose}>
          Отклонить
        </Button>
        <Button color="accepted" variant="contained" onClick={handleClose}>
          Одобрить
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default QuickSolutionDialog
